// Logo images
import image7 from './7.png?format=webp&quality=80';
import image7Fallback from './7.png?quality=80';
import app from './app.png?format=webp&quality=80';
import appFallback from './app.png?quality=80';
// Team member images
import bobGould from './bob_gould.png?format=webp&quality=80';
import bobGouldFallback from './bob_gould.png?quality=80';
import cardGameKonnectBetter from './card_game_konnect_better.png?format=webp&quality=80';
import cardGameKonnectBetterFallback from './card_game_konnect_better.png?quality=80';
import communicationQuiz from './communication_quiz.png?format=webp&quality=80';
import communicationQuizFallback from './communication_quiz.png?quality=80';
import joleneWatkin from './jolene_watkin.png?format=webp&quality=80';
import joleneWatkinFallback from './jolene_watkin.png?quality=80';
// App images
import konnectBetterApp from './konnect_better_app.png?format=webp&quality=80';
import konnectBetterAppFallback from './konnect_better_app.png?quality=80';
import konnectBetterApp2 from './konnect_better_app(2).png?format=webp&quality=80';
import konnectBetterApp2Fallback from './konnect_better_app(2).png?quality=80';
// Book images
import konnectBetterBook from './konnect_better_book.png?format=webp&quality=80';
import konnectBetterBookFallback from './konnect_better_book.png?quality=80';
import konnectBetterBook2 from './konnect_better_book(2).png?format=webp&quality=80';
import konnectBetterBook2Fallback from './konnect_better_book(2).png?quality=80';
import konnectBetterCard from './konnect_better_card.png?format=webp&quality=80';
import konnectBetterCardFallback from './konnect_better_card.png?quality=80';
import konnectBetterCardExample from './konnect_better_card_example.jpg?format=webp&quality=80';
import konnectBetterCardExampleFallback from './konnect_better_card_example.jpg?quality=80';
import konnectBetterCardGame2 from './konnect_better_card_game(2).jpg?format=webp&quality=80';
import konnectBetterCardGame2Fallback from './konnect_better_card_game(2).jpg?quality=80';
// Family image
import konnectBetterFamily from './konnect_better_family.png?format=webp&quality=80';
import konnectBetterFamilyFallback from './konnect_better_family.png?quality=80';
// Notification/Podcast images
import konnectBetterNotifications from './konnect_better_notifications.png?format=webp&quality=80';
import konnectBetterNotificationsFallback from './konnect_better_notifications.png?quality=80';
import konnectBetterPodcast from './konnect_better_podcast.png?format=webp&quality=80';
import konnectBetterPodcastFallback from './konnect_better_podcast.png?quality=80';
import konnectBetterWorkbook from './konnect_better_workbook.png?format=webp&quality=80';
import konnectBetterWorkbookFallback from './konnect_better_workbook.png?quality=80';
import konnectBookHorizontal from './konnect_book_horizontal.png?format=webp&quality=80';
import konnectBookHorizontalFallback from './konnect_book_horizontal.png?quality=80';
import konnectWorkbook2 from './Konnect_Workbook_2.png?format=webp&quality=80';
import konnectWorkbook2Fallback from './Konnect_Workbook_2.png?quality=80';
import konnectBetterBook3 from './konnect-better-book(3).png?format=webp&quality=80';
import konnectBetterBook3Fallback from './konnect-better-book(3).png?quality=80';
import konnectBetterBook4 from './konnect-better-book(4).png?format=webp&quality=80';
import konnectBetterBook4Fallback from './konnect-better-book(4).png?quality=80';
import konnectBetterBook5 from './konnect-better-book(5).png?format=webp&quality=80';
import konnectBetterBook5Fallback from './konnect-better-book(5).png?quality=80';
import konnectBetterBookStyled from './konnect-better-book-styled.png?format=webp&quality=80';
import konnectBetterBookStyledFallback from './konnect-better-book-styled.png?quality=80';
import lilliMarmurek from './lilli_marmurek.png?format=webp&quality=80';
import lilliMarmurekFallback from './lilli_marmurek.png?quality=80';
import logoDark from './logo_dark.png?format=webp&quality=80';
import logoDarkFallback from './logo_dark.png?quality=80';
import logoLight from './logo_light.png?format=webp&quality=80';
import logoLightFallback from './logo_light.png?quality=80';
// Other images
import mediaAssets from './Media Assets (2) 1.png?format=webp&quality=80';
import mediaAssetsFallback from './Media Assets (2) 1.png?quality=80';
import moLidsky from './mo_lidsky.png?format=webp&quality=80';
import moLidskyFallback from './mo_lidsky.png?quality=80';
// Award images
import pinnacleAward from './pinnacle-award.png?format=webp&quality=80';
import pinnacleAwardFallback from './pinnacle-award.png?quality=80';
import relationshipScale from './relationship_scale.png?format=webp&quality=80';
import relationshipScaleFallback from './relationship_scale.png?quality=80';
import sylviaSolit from './sylvia_solit.png?format=webp&quality=80';
import sylviaSolitFallback from './sylvia_solit.png?quality=80';
// Product images
import connectionBlueprint from './The connection blueprint.png?format=webp&quality=80';
import connectionBlueprintFallback from './The connection blueprint.png?quality=80';
import workbookKonnectBetter from './workbook_konnect_better.png?format=webp&quality=80';
import workbookKonnectBetterFallback from './workbook_konnect_better.png?quality=80';

export interface ImageSet {
  webp: string;
  fallback: string;
}

// Export as image sets with webp and fallback
export const images = {
  // Logos
  logoDark: { webp: logoDark, fallback: logoDarkFallback },
  logoLight: { webp: logoLight, fallback: logoLightFallback },
  
  // Awards
  pinnacleAward: { webp: pinnacleAward, fallback: pinnacleAwardFallback },
  
  // Books
  konnectBetterBook: { webp: konnectBetterBook, fallback: konnectBetterBookFallback },
  konnectBetterBook2: { webp: konnectBetterBook2, fallback: konnectBetterBook2Fallback },
  konnectBetterBook3: { webp: konnectBetterBook3, fallback: konnectBetterBook3Fallback },
  konnectBetterBook4: { webp: konnectBetterBook4, fallback: konnectBetterBook4Fallback },
  konnectBetterBook5: { webp: konnectBetterBook5, fallback: konnectBetterBook5Fallback },
  konnectBetterBookStyled: { webp: konnectBetterBookStyled, fallback: konnectBetterBookStyledFallback },
  konnectBookHorizontal: { webp: konnectBookHorizontal, fallback: konnectBookHorizontalFallback },
  
  // App
  konnectBetterApp: { webp: konnectBetterApp, fallback: konnectBetterAppFallback },
  konnectBetterApp2: { webp: konnectBetterApp2, fallback: konnectBetterApp2Fallback },
  app: { webp: app, fallback: appFallback },
  
  // Products
  connectionBlueprint: { webp: connectionBlueprint, fallback: connectionBlueprintFallback },
  workbookKonnectBetter: { webp: workbookKonnectBetter, fallback: workbookKonnectBetterFallback },
  konnectBetterWorkbook: { webp: konnectBetterWorkbook, fallback: konnectBetterWorkbookFallback },
  konnectWorkbook2: { webp: konnectWorkbook2, fallback: konnectWorkbook2Fallback },
  relationshipScale: { webp: relationshipScale, fallback: relationshipScaleFallback },
  communicationQuiz: { webp: communicationQuiz, fallback: communicationQuizFallback },
  cardGameKonnectBetter: { webp: cardGameKonnectBetter, fallback: cardGameKonnectBetterFallback },
  konnectBetterCard: { webp: konnectBetterCard, fallback: konnectBetterCardFallback },
  konnectBetterCardExample: { webp: konnectBetterCardExample, fallback: konnectBetterCardExampleFallback },
  konnectBetterCardGame2: { webp: konnectBetterCardGame2, fallback: konnectBetterCardGame2Fallback },
  
  // Notifications/Podcast
  konnectBetterNotifications: { webp: konnectBetterNotifications, fallback: konnectBetterNotificationsFallback },
  konnectBetterPodcast: { webp: konnectBetterPodcast, fallback: konnectBetterPodcastFallback },
  
  // Family
  konnectBetterFamily: { webp: konnectBetterFamily, fallback: konnectBetterFamilyFallback },
  
  // Team
  bobGould: { webp: bobGould, fallback: bobGouldFallback },
  joleneWatkin: { webp: joleneWatkin, fallback: joleneWatkinFallback },
  lilliMarmurek: { webp: lilliMarmurek, fallback: lilliMarmurekFallback },
  moLidsky: { webp: moLidsky, fallback: moLidskyFallback },
  sylviaSolit: { webp: sylviaSolit, fallback: sylviaSolitFallback },
  
  // Other
  mediaAssets: { webp: mediaAssets, fallback: mediaAssetsFallback },
  image7: { webp: image7, fallback: image7Fallback },
} as const;

// Path mapping for backward compatibility
export const imagePathMap: Record<string, ImageSet> = {
  '/logo_dark.png': images.logoDark,
  '/logo_light.png': images.logoLight,
  '/pinnacle-award.png': images.pinnacleAward,
  '/images/konnect_better_book.png': images.konnectBetterBook,
  '/images/konnect_better_book(2).png': images.konnectBetterBook2,
  '/images/konnect-better-book(3).png': images.konnectBetterBook3,
  '/images/konnect-better-book(4).png': images.konnectBetterBook4,
  '/images/konnect-better-book(5).png': images.konnectBetterBook5,
  '/images/konnect-better-book-styled.png': images.konnectBetterBookStyled,
  '/images/konnect_book_horizontal.png': images.konnectBookHorizontal,
  '/images/konnect_better_app.png': images.konnectBetterApp,
  '/images/konnect_better_app(2).png': images.konnectBetterApp2,
  '/images/app.png': images.app,
  '/images/the_connection_blueprint.png': images.connectionBlueprint,
  '/images/workbook_konnect_better.png': images.workbookKonnectBetter,
  '/images/konnect_better_workbook.png': images.konnectBetterWorkbook,
  '/images/Konnect_Workbook_2.png': images.konnectWorkbook2,
  '/images/relationship_scale.png': images.relationshipScale,
  '/images/communication_quiz.png': images.communicationQuiz,
  '/images/card_game_konnect_better.png': images.cardGameKonnectBetter,
  '/images/konnect_better_card.png': images.konnectBetterCard,
  '/images/konnect_better_card_example.jpg': images.konnectBetterCardExample,
  '/images/konnect_better_card_game(2).jpg': images.konnectBetterCardGame2,
  '/images/konnect_better_notifications.png': images.konnectBetterNotifications,
  '/images/konnect_better_podcast.png': images.konnectBetterPodcast,
  '/images/konnect_better_family.png': images.konnectBetterFamily,
  '/images/bob_gould.png': images.bobGould,
  '/images/jolene_watkin.png': images.joleneWatkin,
  '/images/lilli_marmurek.png': images.lilliMarmurek,
  '/images/mo_lidsky.png': images.moLidsky,
  '/images/sylvia_solit.png': images.sylviaSolit,
  '/images/Media Assets (2) 1.png': images.mediaAssets,
  '/images/7.png': images.image7,
};

export function getImageSet(path: string): ImageSet | null {
  return imagePathMap[path] || null;
}
